<template>
  <div class="tag">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import '~style/variables';

.tag {
  border-radius: $r;
  background: $c-main;
  color: #fff;
  display: inline-block;
  font-size: $h7;
  font-weight: $semibold;
  line-height: $lh;
  text-align: center;
  padding: 0 1rem;

  .field {
    background: transparent;
    border: 0;
    margin-bottom: 0;
    select {
      background: transparent;
      color: inherit;
      option {
        color: $c-text-mid;
      }
    }
    &.with-icon {
      background: transparent;
      border: none;
    }
  }

  &.dot:before {
    background: #fff;
    border-radius: $r-round;
    display: inline-block;
    content: ' ';
    height: 0.5rem;
    margin-right: 0.25rem;
    width: 0.5rem;
  }

  &.inv {
    &:before {
      background: $c-main;
    }
  }

  &.light {
    background: $c-info-light;
    color: $c-info;
  }

  // size
  &.xs {
    padding: 0 0.25rem;
    line-height: 0.75 * $lh;
  }

  // theme
  &.danger {
    background: $c-danger;
    &.inv, &.light {
      color: $c-danger;
    }
    &.light {
      background: $c-danger-light;
    }
    &:not(.inv):before {
      background: $c-danger;
    }
  }
  &.info {
    background: $c-info;
    &.inv, &.light {
      color: $c-info;
    }
    &.light {
      background: $c-info-light;
    }
    &:not(.inv):before {
      background: $c-info;
    }
  }
  &.success {
    background: $c-success;
    &.inv, &.light {
      border-color: $c-success;
      color: $c-success;
    }
    &.light {
      background: $c-success-light;
    }
    &:not(.inv):before {
      background: $c-success;
    }
  }
  &.warning {
    background: $c-warning;
    &.inv, &.light {
      color: $c-warning;
    }
    &.light {
      background: $c-warning-light;
    }
    &:not(.inv):before {
      background: $c-warning;
    }
  }
  &.neutral {
    background: $c-neutral-light;
    border: 1px solid $c-border-light;
    color: $c-text-mid;
    &.inv, &.light {
      border-color: $c-neutral-light;
      color: $c-neutral-light;
    }
    // &.light {
    //   background: $c-neutral-light;
    // }
    &:not(.inv):before {
      background: $c-neutral-light;
    }
  }
  &.inv {
    background: transparent;
    padding: 0;
    color: $c-link;
    border: 1px solid $c-main;
  }
  &.no-border {
    border: 0;
  }

  &.no-pad {
    padding: 0;
  }
  &.small-pad {
    border: 0;
    padding: 0 0.25rem;
  }

  // shape
  &.round {
    border-radius: $r-round;
  }
  &.box {
    height: 2rem;
    line-height: 2rem;
    padding: 0;
    text-align: center;
    width: 2rem;
    &.lg {
      height: 2.75rem;
      line-height: 2.75rem;
      width: 2.75rem;
    }
  }

  // display
  &.db {
    display: block;
    // margin-bottom: 0.5rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/components/globals/Tag.vue